import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { BodySmall, RichTextHeadline } from 'components/Text';

type HeaderProps = {
  layout: 'SLIM' | 'REGULAR';
  headline: string | null | undefined;
  linkNode: ReactNode | null | undefined;
};
const SlimRichTextHeadline = styled(RichTextHeadline)`
  h2 {
    margin: 0 !important;
  }

  h2::before {
    display: none !important;
  }
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const TileCarouselHeader = ({
  layout,
  headline,
  linkNode,
}: HeaderProps) => {
  if (layout === 'REGULAR')
    return (
      <>
        <RichTextHeadline textAlign="center">{headline}</RichTextHeadline>

        {linkNode && (
          <BodySmall textAlign={['center', null, null, 'right']} mb={20}>
            {linkNode}
          </BodySmall>
        )}
      </>
    );
  return (
    <Box
      display="flex"
      flexDirection={['column', 'column', 'row', 'row']}
      justifyContent={[null, null, 'space-between', 'space-between']}
      alignItems={['start', 'start', 'end', 'end']}
      gridGap={8}
      mb={48}
    >
      <SlimRichTextHeadline>{headline}</SlimRichTextHeadline>
      <BodySmall>{linkNode}</BodySmall>
    </Box>
  );
};
